import React from 'react';
import {throttle} from 'throttle-debounce';
import Grid from '@material-ui/core/Grid';
import StaticView from '../motionView/staticView';
import dateformat from 'dateformat';

import './motionGallery.scss';

export default class GalleryItem extends React.Component {
    
    constructor() {
        super();
        this.state = {isMobile: true, isHovered: false, lastUpdate: Date.now()}; // This lets us reanimate the gallery item on hover
        this.loopingIntervals = [];
        this.throttledOnResize = throttle(300, this.onResize);
    }

    componentDidMount() {
        window.addEventListener('resize', this.onResize);
        this.onResize();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize);
        this.clearAllIntervals();
    }

    onResize = () => {
        this.setState({isMobile: window.innerWidth <= 768});
    }

    onRemoveItem = (optionIndex) => {
        const {onRemoveSnapshot} = this.props;
        const response = window.confirm("Are you sure you want to delete this snapshot?");
        if(response) {
            onRemoveSnapshot(optionIndex);
        }
    }

    clearAllIntervals = () => {
        // Consider removing this strategy in favor of pure CSS animations with Infinite looping.
        return new Promise((resolve, _) => {
            if(this.loopingIntervals.length < 1) resolve();
            this.loopingIntervals.forEach((interval, index, arr) => {  
                clearInterval(interval);    
                if(index === arr.length - 1) {
                    this.loopingIntervals = [];
                    resolve();
                }
            });
        });
    }

    onTouchStart = () => {
        this.setState({lastUpdate: Date.now()});
    }

    onTouchEnd = () => {
        this.clearAllIntervals();
    }

    onMouseLeave = () => {
        this.clearAllIntervals();        
        this.setState({isHovered: false})
    }

    onMouseEnter = () => {
        const {preset} = this.props;
        const {duration} = preset;
        const animationPause = 1200; // ms   Time between each animation loop.
        
        this.clearAllIntervals().then(_ => {
            
            const newIntervalId = setInterval(() => {
                this.setState({lastUpdate: Date.now()});
            }, duration + animationPause);
    
            this.loopingIntervals.push(newIntervalId);
            this.setState({isHovered: true, lastUpdate: Date.now()});
        });

    }

    render() {        
        const {copy, index, preset, onItemClick, onSnapshotClick, scale, savedDate} = this.props;
        const {isHovered, lastUpdate} = this.state;
        const formattedDate = savedDate ? dateformat(parseInt(savedDate), 'yyyy-mm-dd, h:MM TT') : null;
        const isSnapshot = !!savedDate;

        return (
            <Grid 
                key={lastUpdate}
                className="gallery-item-wrapper"
                item lg={3}
                onTouchStart={this.onTouchStart}
                onTouchEnd={this.onTouchEnd}
                onMouseEnter={this.onMouseEnter}
                onMouseLeave={this.onMouseLeave}
            >
                {isSnapshot && isHovered && <div className="gallery-item-remove" onClick={() => {this.onRemoveItem(index)}}>x</div>}
                {isSnapshot && <div className="gallery-item-saved-date">{formattedDate}</div>}
                <div 
                    className="gallery-item"
                    style={{transform: `scale(${scale})`}} 
                    onClick={_ => savedDate ? onSnapshotClick(index) : onItemClick(index)}
                >
                    <StaticView {...this.props} copy={copy} transitionOptions={preset} />
                </div>
            </Grid>
        );
    }  
}